import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {BookOpen, Bot, Video, Smartphone, Users, Award, ArrowRight} from 'lucide-react'

const produtos = [
  {
    title: "EW Pass",
    subtitle: "Plataforma completa de inglês",
    desc: "O EW Pass é a principal solução da English Work. Uma plataforma digital que reúne tudo o que o aluno precisa para aprender inglês de forma estruturada, prática e contínua.",
    features: [
      { icon: BookOpen, text: "EW Academy — mais de 400 horas de aulas" },
      { icon: Bot, text: "Lucy IA — tutora virtual 24h via WhatsApp" },
      { icon: Video, text: "EW Live — aulas ao vivo semanais" },
      { icon: Smartphone, text: "Apps para iOS e Android" },
      { icon: Users, text: "Comunidade exclusiva com gamificação" },
      { icon: Award, text: "Certificados de conclusão" },
    ],
    color: "#0E8EA0",
    highlight: true,
  },
  {
    title: "EW Academy",
    subtitle: "Plataforma de aulas gravadas",
    desc: "Mais de 400 horas de conteúdo estruturado por nível, com videoaulas, exercícios e materiais complementares. Estude no seu ritmo, de qualquer lugar.",
    features: [
      { icon: BookOpen, text: "Conteúdo do básico ao avançado" },
      { icon: Video, text: "Videoaulas com professores nativos" },
      { icon: Award, text: "Exercícios e avaliações por módulo" },
    ],
    color: "#B038B2",
    highlight: false,
  },
  {
    title: "Lucy IA",
    subtitle: "Tutora virtual inteligente",
    desc: "A Lucy é a tutora virtual da English Work, disponível 24 horas por dia via WhatsApp. Ela tira dúvidas, corrige pronúncia, pratica conversação e acompanha seu progresso.",
    features: [
      { icon: Bot, text: "Disponível 24h via WhatsApp" },
      { icon: Users, text: "Conversação e prática de pronúncia" },
      { icon: Award, text: "Feedback personalizado" },
    ],
    color: "#F5C542",
    highlight: false,
  },
]

export default function Produtos() {
  const section1 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Nossos Produtos"
        subtitle="Conheça as soluções educacionais da English Work para transformar seu aprendizado de inglês."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="space-y-10">
            {produtos.map((prod) => (
              <div
                key={prod.title}
                className={`rounded-2xl p-8 md:p-10 border transition-all duration-300 hover:shadow-lg ${
                  prod.highlight ? "border-2" : "border-gray-100"
                }`}
                style={prod.highlight ? { borderColor: prod.color } : {}}
              >
                {prod.highlight && (
                  <span
                    className="inline-block text-xs font-bold px-3 py-1 rounded-full text-white mb-4"
                    style={{ backgroundColor: prod.color }}
                  >
                    PRODUTO PRINCIPAL
                  </span>
                )}
                <h3 className="text-2xl font-bold text-gray-900 mb-1">{prod.title}</h3>
                <p className="text-sm font-semibold mb-4" style={{ color: prod.color }}>{prod.subtitle}</p>
                <p className="text-gray-600 leading-relaxed mb-6 max-w-2xl">{prod.desc}</p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
                  {prod.features.map((feat) => (
                    <div key={feat.text} className="flex items-center gap-3 p-3 rounded-xl bg-gray-50">
                      <feat.icon size={18} style={{ color: prod.color }} className="shrink-0" />
                      <span className="text-sm text-gray-700">{feat.text}</span>
                    </div>
                  ))}
                </div>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 mt-6 text-sm font-bold transition-colors hover:underline"
                  style={{ color: prod.color }}
                >
                  Saiba mais <ArrowRight size={14} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
